module.exports = __webpack_public_path__ + "static/media/fallCropped.07f51ca2.jpg";